// src/packages/viriyah/motor/viriyah_ev_type1_2to5/index.js
import EVType1Card from "./EVType1Card";
import EVType1Details from "./EVType1Details";
import "./ev_type1.css";

/**
 * Viriyah EV Type 1 (2–5 ปี, ซ่อมห้าง)
 */
export default {
  id: "viriyah_ev_type1_2to5",
  company: "วิริยะประกันภัย",
  productLine: "motor",
  categories: ["ev"],
  nameTH: "EV ประเภท 1 (2–5 ปี) — ซ่อมห้าง",
  description: "เบี้ยรวมคงที่ตามรุ่นยอดนิยม พร้อมส่วนลด CCTV+App ตามเงื่อนไขบริษัท",
  accent: "#004aad",
  expiresAt: "2025-12-31",
  card: EVType1Card,
  detail: EVType1Details,
  active: true,
};
